import { Injectable, InjectionToken } from '@angular/core';

export const ENVIRONMENTER = new InjectionToken('Environmenter');

@Injectable()
export class BaseEnvironmenterTokenService {}
